// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
    width: 360px;
    background: #111;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: white;
}

.sidebar__header {
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 16px 20px;
    background: #0b0b0b;
}

.username {
    font-weight: 600;
}

.sidebar__nav {
    display: flex;
    justify-content: center;
    gap: 12px;
    padding: 20px;
}

.sidebar-btn {
    padding: 4px 14px;
    border-radius: 20px;
    font-size: 0.8rem;
    background: #1d1d1d;
    color: #9d9d9d;
    border: none;
    cursor: pointer;
}

.sidebar-btn:hover {
    background: #d5d5d5;
}

.sidebar-btn.active {
    background: #2f2f2f;
    color: #fff;
}

.matches {
    list-style: none;
    padding: 20px;
    margin: 0 40px 0 0;
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.match {
    display: flex;
    align-items: center;
    gap: 20px;
    cursor: pointer;
}

.match__avatar {
    width: 32px;
    height: 32px;
    border-radius: 6px;
    background: #d9d9d9;
}

.match__name {
    font-weight: bold;
}

.conversation-info {
    display: flex;
    gap: 2px;
    flex-direction: column;
}

.conversation-info span {
    font-size: 16px;
    margin-bottom: 4px;
}

.last-message {
    font-size: 14px;
    color: #666;
    margin: 0;
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.logout-button {
    margin-top: 60px;
    margin-bottom: 24px;
    background: #1CD66A;
    font-weight: bold;
    font-size: 14px;
    width: 180px;
    border: none;
    padding: 14px;
    border-radius: 24px;
    cursor: pointer;
    transition: background 0.3s;
    align-self: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/sidebar.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,2BAA2B;IAC3B,kBAAkB;AACtB","sourcesContent":[".sidebar {\n    width: 360px;\n    background: #111;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    color: white;\n}\n\n.sidebar__header {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    padding: 16px 20px;\n    background: #0b0b0b;\n}\n\n.username {\n    font-weight: 600;\n}\n\n.sidebar__nav {\n    display: flex;\n    justify-content: center;\n    gap: 12px;\n    padding: 20px;\n}\n\n.sidebar-btn {\n    padding: 4px 14px;\n    border-radius: 20px;\n    font-size: 0.8rem;\n    background: #1d1d1d;\n    color: #9d9d9d;\n    border: none;\n    cursor: pointer;\n}\n\n.sidebar-btn:hover {\n    background: #d5d5d5;\n}\n\n.sidebar-btn.active {\n    background: #2f2f2f;\n    color: #fff;\n}\n\n.matches {\n    list-style: none;\n    padding: 20px;\n    margin: 0 40px 0 0;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n.match {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    cursor: pointer;\n}\n\n.match__avatar {\n    width: 32px;\n    height: 32px;\n    border-radius: 6px;\n    background: #d9d9d9;\n}\n\n.match__name {\n    font-weight: bold;\n}\n\n.conversation-info {\n    display: flex;\n    gap: 2px;\n    flex-direction: column;\n}\n\n.conversation-info span {\n    font-size: 16px;\n    margin-bottom: 4px;\n}\n\n.last-message {\n    font-size: 14px;\n    color: #666;\n    margin: 0;\n    max-width: 200px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.logout-button {\n    margin-top: 60px;\n    margin-bottom: 24px;\n    background: #1CD66A;\n    font-weight: bold;\n    font-size: 14px;\n    width: 180px;\n    border: none;\n    padding: 14px;\n    border-radius: 24px;\n    cursor: pointer;\n    transition: background 0.3s;\n    align-self: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
